import { logEvent } from 'firebase/analytics'
import analytics from '../config/firebase'
import mixpanel from 'mixpanel-browser'

mixpanel.init(process.env.REACT_APP_MIXPANEL_API_KEY, { debug: false })

const logAppEvent = async (eventName, data) => {
  try {
    logEvent(analytics, eventName, data)
    if (process.env.REACT_APP_NODE_ENV !== 'production') {
      // console.log(eventName, analytics, data)
    }
  } catch (error) {
    // console.log(error)
  }
  if (eventName !== 'screen_view') {
    if (data?.user_id) {
      mixpanel.identify(data.user_id)
    }
    mixpanel.track(eventName, data)
  }

}
export default logAppEvent
